<template>
    <div class="top_nav" :class="isClass ? 'change_bg' : no_bg" ref="fullPage">
        <div class="navigation">
            <div class="logo" :class="isClass ? 'logo_act' : ''">金华市公共算力服务平台</div>
            <div :class="isClass ? 'nav_list_act' : 'nav_list'">
                <div :class="active == index ? 'nav_item_act' : 'nav_item'" v-for="(item, index) in list" :key="index"
                    @click="toPage(item)">
                    {{ item.name }}</div>
            </div>
            <div :class="isClass ? 'btn_act' : 'btn'">
                <!-- <div class="btn_item" @click="dialogVisible = true">登录</div>
                <div class="btn_item" @click="register">注册</div> -->
                <div class="btn_item" @click="login">登录</div>
                <div class="btn_item" @click="registerTo">注册</div>
            </div>


        </div>
        <el-dialog :visible.sync="dialogVisible" width="960px" :before-close="handleClose" class="dialog-wrapper"
            :modal-append-to-body="false">
            <div class="dialog_box">
                <div class="exit" @click="dialogVisible = false"><i class="el-icon-plus"></i></div>
                <div class="dialog_left">
                    <img src="@/assets/img/位图@2x (21).png">
                    <div class="dialog_title">
                        <div class="dialog_title_top">Hello！欢迎进入</div>
                        <div class="dialog_title_top">金华市公共算力服务平台</div>
                    </div>
                </div>
                <div class="dialog_right">
                    <div class="height_auto">
                        <div class="logo">LOGO</div>
                        <div class="login_type">
                            <div class="login_left" :class="isPwd == 0 ? 'login_act' : ''" @click="isPwd = 0">账号登录</div>
                            <div class="login_left" :class="isPwd == 1 ? 'login_act' : ''" @click="isPwd = 1">短信登录</div>
                        </div>
                        <div class="input_box" v-if="isPwd == 0">
                            <el-form ref="form" :model="form" label-width="0px" :rules="rules">
                                <el-form-item prop="userName">
                                    <el-input style="width: 334px;" v-model="form.userName"
                                        placeholder="账号/手机号"></el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <el-input style="width: 334px;" v-model="form.password" placeholder="密码"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="code_login" v-if="isPwd == 1">
                            <el-form ref="form" :model="form" label-width="0px" :rules="rules">
                                <el-form-item prop="phone">
                                    <el-input style="width: 334px;" v-model="form.phone" placeholder="手机号"></el-input>
                                </el-form-item>
                                <el-form-item prop="code">
                                    <div class="code_la">
                                        <el-input style="width: 200px;" v-model="form.code" type="number"
                                            placeholder="验证码"></el-input>
                                        <el-button disabled>获取验证码</el-button>
                                    </div>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="register">
                            <div class="register_left"><el-checkbox v-model="checked"><span>记住用户名</span></el-checkbox>
                            </div>
                            <div class="register_right">
                                <div class="right_paw">注册账号</div>
                                <div class="right_forget">忘记账号/密码</div>
                            </div>
                        </div>
                        <div class="submit_btn" @click="submitForm('form')">
                            登录
                        </div>
                    </div>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        isClass: Boolean, // 是否改变颜色
        // 激活的导航
        active: {
            type: Number, // 默认为0
            default: 0
        },
    },
    data() {
        return {
            form: {
                userName: '',
                password: '',
                code: '',
                phone: ''
            },
            checked: false,
            isPwd: 0,
            list: [
                { name: '首页', url: '/' },
                { name: '金智云', url: '/cloud' },
                { name: '算力市场', url: '/calculate' },
                { name: '生态市场', url: '/ecology' },
                { name: '优惠政策', url: '/preferential' },
                { name: '关于我们', url: '/about' },
            ],
            change_bg: 'change_bg',
            no_bg: '',
            dialogVisible: false,
            rules: {
                userName: [
                    { required: true, message: '请输入账号/手机号', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                ],
            }
        }
    },
    // 监听props中的isClass变化
    watch: {
        isClass(newValue, oldValue) {
            if (!newValue) {
                this.no_bg = 'no_bg'
            }
        }
    },
    mounted() {
        let minWidth = window.screen.width;
        this.$refs["fullPage"].style.minWidth = minWidth + "px";
    },
    methods: {
        toPage(item) {
            this.$router.push(item.url)
        },
        handleClose() {
            this.dialogVisible = false
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        register(){
            this.$router.push('/register')
        },
        login(){
            window.open('http://www.ctjhzs.com:1180/cpn/#')
        },
        registerTo(){
            window.open('http://www.ctjhzs.com:1180/cpnportal/register')
        }

    },

}
</script>

<style lang="scss" scoped>
.top_nav {
    width: 100%;
    height: 82px;
    background: rgba(0, 13, 52, 0.46);
    // position: sticky;
    // top: 0%;
    // left: 0%;
}

.change_bg {
    animation: bg_color 1s;
    animation-fill-mode: forwards;
}

.no_bg {
    animation: no_bg 1s;
    animation-fill-mode: forwards;
}

@keyframes bg_color {
    0% {
        background: rgba(0, 13, 52, 0.46);
    }

    100% {
        background: #fff;

    }
}

@keyframes no_bg {
    0% {
        background: #fff;
    }

    100% {
        background: rgba(0, 13, 52, 0.46);
    }
}

.navigation {
    color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    position: relative;
    .logo{
        // position: absolute;
        // left: 15%;
        font-weight: bold;
        font-size: 18px;
        font-style: italic;
        letter-spacing: 2px;	
    }
    .logo_act{
        color: #094990;
    }
    .nav_list {
        display: flex;
        align-items: center;

        .nav_item {
            display: inline-block;
            font-weight: 500;
            font-size: 18px;
            color: #CCCCCC;
            margin-right: 30px;
            cursor: pointer;
            position: relative;



            &::after {
                content: '';
                position: absolute;
                width: 50%;
                transform: scaleX(0);
                height: 3px;
                bottom: -5px;
                left: 0;
                background-color: #fff;
                transform-origin: bottom left;
                transition: transform 0.25s ease-out;
            }

            &::before {
                content: '';
                position: absolute;
                width: 50%;
                transform: scaleX(0);
                height: 3px;
                bottom: -5px;
                right: 0;
                background-color: #fff;
                transform-origin: bottom right;
                transition: transform 0.25s ease-out;
            }

            &:hover::after {
                transform: scaleX(1);
                transform-origin: bottom left;
            }

            &:hover::before {
                transform: scaleX(1);
                transform-origin: bottom right;
            }
        }

        .nav_item_act {
            display: inline-block;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
            margin-right: 30px;
            cursor: pointer;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                width: 100%;
                height: 3px;
                bottom: -5px;
                left: 0;
                background-color: #fff;
            }
        }


        .active {}
    }

    .nav_list_act {
        display: flex;
        align-items: center;

        .nav_item {
            display: inline-block;
            font-weight: 500;
            font-size: 18px;
            color: #000;
            margin-right: 30px;
            cursor: pointer;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                width: 50%;
                transform: scaleX(0);
                height: 3px;
                bottom: -5px;
                left: 0;
                background-color: #000;
                transform-origin: bottom left;
                transition: transform 0.25s ease-out;
            }

            &::before {
                content: '';
                position: absolute;
                width: 50%;
                transform: scaleX(0);
                height: 3px;
                bottom: -5px;
                right: 0;
                background-color: #000;
                transform-origin: bottom right;
                transition: transform 0.25s ease-out;
            }

            &:hover::after {
                transform: scaleX(1);
                transform-origin: bottom left;
            }

            &:hover::before {
                transform: scaleX(1);
                transform-origin: bottom right;
            }
        }

        .nav_item_act {
            display: inline-block;
            font-weight: 500;
            font-size: 18px;
            color: #000;
            margin-right: 30px;
            cursor: pointer;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                width: 100%;
                height: 3px;
                bottom: -5px;
                left: 0;
                background-color: #000;
            }
        }
    }

    .btn {
        // position: absolute;
        // right: 20%;
        display: flex;
        justify-content: center;
        align-items: center;

        .btn_item {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 31px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 4px;
            border: 1px solid #8C95A8;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 20px;
            margin-right: 10px;
            cursor: pointer;

            &:hover {
                background: #fff;
                color: #094990;
            }
        }
    }

    .btn_act {
        // position: absolute;
        // right: 20%;
        display: flex;
        justify-content: center;
        align-items: center;

        .btn_item {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 31px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 4px;
            border: 1px solid #094990;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #094990;
            line-height: 20px;
            margin-right: 10px;
            cursor: pointer;

            &:hover {
                background: #094990;
                color: #fff;
            }
        }
    }
}

.dialog-wrapper {
    .dialog_box {
        display: flex;
        height: 506px;
        border-radius: 20px;
        position: relative;

        .exit {
            position: absolute;
            top: 10px;
            right: 10px;
            transform: rotate(-45deg);
            font-size: 22px;
            cursor: pointer;
        }

        .dialog_left {
            position: relative;

            img {
                width: 404px;
                height: 506px;
            }

            .dialog_title {
                position: absolute;
                top: 12%;
                left: 10%;

                .dialog_title_top {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 18px;
                    color: #FFFFFF;
                    margin-bottom: 6px;
                }

            }
        }

        .dialog_right {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;

            .height_auto {
                height: 400px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-evenly;
            }

            .logo {
                width: 187px;
                height: 70px;
                background: #094990;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 18px;
                color: #FFFFFF;
            }

            .login_type {
                width: 187px;
                display: flex;
                align-items: center;
                justify-content: space-around;

                .login_left {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    cursor: pointer;
                    position: relative;

                    &.login_act {
                        &::after {
                            content: '';
                            position: absolute;
                            width: 100%;
                            height: 3px;
                            bottom: -8px;
                            left: 0;
                            background-color: #000;
                        }
                    }
                }
            }

            .input_box {
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .code_login {
                display: flex;
                flex-direction: column;
                align-items: center;

                .code_la {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
            }

            .register {
                width: 334px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: -10px;

                .register_left {
                    span {
                        font-family: AlibabaPuHuiTiR;
                        font-size: 12px;
                        color: #606266;
                    }

                }

                .register_right {
                    display: flex;
                    align-items: center;


                    .right_paw,
                    .right_forget {
                        font-family: AlibabaPuHuiTiR;
                        font-size: 12px;
                        color: #094990;
                        line-height: 17px;
                        text-decoration-line: underline;
                        margin-right: 10px;
                    }

                }
            }

            .submit_btn {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 334px;
                height: 31px;
                background: #094990;
                border-radius: 16px;
                font-family: AlibabaPuHuiTiR;
                font-size: 12px;
                color: #FFFFFF;
                letter-spacing: 8px;
                cursor: pointer;

            }
        }
    }

    :deep(.el-dialog) {
        border-radius: 15px;

        .el-icon-close:before {
            display: none;
        }

        .el-dialog__header {
            display: none;
            padding: 0;

            button {
                z-index: 999;
                margin-right: 20px;
            }
        }

        .el-dialog__body {
            padding: 0;
            border-radius: 14px;
        }
    }
}
</style>